import styled from '@emotion/styled';
import { chakra, IconButton } from '@chakra-ui/react';

export const StyledShoppingItemContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  gap: 8px;
  flex-direction: column;
  padding: 16px;

  .shopping-item-description {
    overflow: hidden;
   text-overflow: ellipsis;
   display: -webkit-box;
   -webkit-line-clamp: 2; /* number of lines to show */
           line-clamp: 2; 
   -webkit-box-orient: vertical;
  }
`;

export const TrashButton = chakra(IconButton, {
  baseStyle: {
    borderWidth: '1px',
    borderColor: 'neutral.500',
    backgroundColor: 'white',
  },
});

export const StyledTrashButton = styled(TrashButton)`
  position: relative;
`;
